import { KalturaRuleType } from '@kaltura-ott/ott-client-types/api/types';
import { KalturaUserAssetRule } from '@kaltura-ott/ott-client-types/api/types/KalturaUserAssetRule';

export const filterRules = (rules: KalturaUserAssetRule[] = [], type: KalturaRuleType): KalturaUserAssetRule[] => {
  return rules.filter((rule) => rule.ruleType === type);
};
